import { IApplicationState } from '../../types/redux';

export const isErrorOpenedSelector = (state: IApplicationState): boolean => {
  return state.consultantCianChat.isErrorPopupOpened;
};
